import { render, staticRenderFns } from "./ContentBottom.vue?vue&type=template&id=a0f15cb4&"
import script from "./ContentBottom.vue?vue&type=script&lang=ts&"
export * from "./ContentBottom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports